/*
 * Flatpickr Year Select Plugin.
 * @author Labi 
 *
 * @returns {Function}
 */
/* eslint-disable */
const getFormattedTime = function (date) {
    var hours = date.getHours();
    var minutes = date.getMinutes();
    var seconds = date.getSeconds();


    return [hours, (minutes > 9 ? '' : '0') + minutes, (seconds > 9 ? '' : '0') + seconds].join(':');
};
const getUKFormattedDate = function () {
    var date = new Date();
    var month = date.getMonth() + 1;
    var day = date.getDate();

    return [date.getFullYear(), (month > 9 ? '' : '0') + month, (day > 9 ? '' : '0') + day].join('-') + "T" + getFormattedTime(date) + "Z";

};

const yearDropdownPlugin = function (pluginConfig) {
    var defaultConfig = {
        text: '',
        theme: "light",
        date: getUKFormattedDate(),
        yearStart: 100,
        yearEnd: 2,

    };

    var config = {};
    for (var key in defaultConfig) {
        config[key] = pluginConfig && pluginConfig[key] !== undefined ? pluginConfig[key] : defaultConfig[key];
    }

    var getYear = function (value) {
        if (value != null && value != "") {
            var date = value.split("/");
            return parseInt(date[0], 10);
        }
        return new Date().getFullYear();
    }

    var selectedYear = getYear(config.date);

    var yearDropdown = document.createElement("select");

    var createSelectElement = function (year) {

        if (typeof (config.yearStart) !== "number") {
            config.yearStart = new Date(new Date().getFullYear() - 100);
        }
        if (typeof (config.yearEnd) !== "number") {
            config.yearEnd = new Date().getFullYear();
        }

        var start = config.yearStart;
        var end = config.yearEnd;

        //stackoverflow check
        if (end - start > 300) {
            // this is an error. we should never get here
            start = config.yearEnd - 300;
            end = config.yearEnd;
            // eslint-disable-next-line no-console
            console.log("Date ERROR!");
        }

        for (var i = end; i >= start; i--) {
            var option = document.createElement("option");
            option.value = i;
            option.text = i;
            yearDropdown.appendChild(option);
        }
        yearDropdown.value = selectedYear;
    };

    return function (fp) {
        fp.yearSelectContainer = fp._createElement(
            "div",
            "flatpickr-year-select " + config.theme + "Theme",
            config.text
        );

        fp.yearSelectContainer.tabIndex = -1;
        createSelectElement(selectedYear);
        yearDropdown.addEventListener('change', function (evt) {
            var year = evt.target.options[evt.target.selectedIndex].value;
            fp.changeYear(year);
        });

        fp.yearSelectContainer.append(yearDropdown);

        return {
            onReady: function onReady() {
                fp.calendarContainer.appendChild(fp.yearSelectContainer);
            }
        };
    };
};

export default yearDropdownPlugin;
// if (typeof module !== "undefined")
//     module.exports = yearDropdownPlugin;